import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormHelperText, TextField, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Feature, mapToNewFeature, Plan, TierOccurrence } from "../../models/plans.model";
import { PlansService } from "../../services/plans.service";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ToasterTexts, buttonLabels } from "../shared/constants";
import setToast from "../../helpers/toaster.helper";
import { CancelIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { Autocomplete } from "@mui/material";
import { countries } from "../../helpers/countries";
import { FeatureService } from "../../services/FeatureService";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { privateEncrypt } from "crypto";

interface IProps {
    IsEdit?: boolean;
    IsDuplicate?: boolean;
    show: boolean;
    OnClose: (isConfim?: boolean) => void;
    Tier?: Plan;
}

const CreatEditAddon = (props: IProps) => {
    const navigate = useNavigate()
    let tierOccurrences = [{ Name: "One Time", Value: TierOccurrence.ONE_TIME }, { Name: "Recurring", Value: TierOccurrence.RECURRING }];

    // const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    let tier = props.Tier;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [name, setName] = useState<string>(tier ? tier.Name : "");
    const [price, setPrice] = useState<number>(tier ? tier.Price : undefined);
    const [footnote, setFootnote] = useState<string>(tier ? tier.FootNote : undefined);
    const [tierOccurrence, setTierOccurrence] = useState<any>(tier?.TierOccurrence ? tier?.TierOccurrence : 1);
    // const [isPrivate, setIsPrivate] = useState<boolean | -1>(tier ? tier.IsPrivate : -1);
    // const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>(!!tier?.SelectedOrganizations ? tier?.SelectedOrganizations : []);
    const [country, setCountry] = useState<string>(tier ? tier.Country : "US");
    const [errors, setErrors] = useState<any>({ AddonName: '', Price: '', Value: '', TierOccurrence: '', FootNote: '' });
    const [features, setFeatures] = useState<Feature[]>([])
    const [selectedFeature, setSelectedFeature] = useState<Feature>(null)
    const [isUnlimited, setIsUnlimited] = useState<boolean>()
    const [value, setValue] = useState<string>("")
    const [selectedFeatureError, setSelectedFeatureError] = useState<string>("")

    const onSubmitAddon = (event: any) => {
        setIsLoading(true);
        const feature: any = { ...selectedFeature }
        feature.Value = !!value ? value : "-1"
        feature.Validity = isUnlimited ? "-1" : null
        const planData = {
            id: props.IsEdit ? tier.Id : "",
            name: name,
            fNotes: footnote,
            price: Number(price),
            country: country || '',
            color: "#000",
            planType: 2,
            features: [feature],
            occurrenceType: tierOccurrence,
            isDeleted: true,
        };
        if (props.IsEdit) {
            PlansService.updateNewPlans(planData).then((res) => {
                setToast(ToasterTexts.TIER_EDIT_SUCCESS.replace('<Name>', name), ToasterType.SUCCESS)
                navigate(AppRoutes.NEW_PLANS);
                props.OnClose(true)
            }).catch((err) => { setToast(err.response.data.message, ToasterType.DANGER); setIsLoading(false); })
        }
        else {
            PlansService.createNewPlan(planData)
                .then(() => {
                    setToast(ToasterTexts.TIER_ADD_SUCCESS.replace('<Name>', name), ToasterType.SUCCESS)
                    navigate(AppRoutes.NEW_PLANS);
                    props.OnClose(true)
                }).catch((error) => { setToast(error.response.data.message, ToasterType.DANGER); setIsLoading(false); });
        }
    }

    const handlePrice = (e) => {
        const value = e.target.value;
        const isValidPrice = /^\d{0,5}(\.\d{0,2})?$/.test(value);
        if (isValidPrice || value === '') {
            setErrors({ ...errors, Price: value.length === 0 ? "Required*" : '' });
            setPrice(value);
        }
    }

    const isValidForm = () => {
        return Object.values(errors).every(value => value === "") && (!!name && !!tierOccurrence && !!country && !!price && !!selectedFeature?.Code && (isUnlimited || !!value));
    }

    const handleTierOccurrenceChange = (object: any, value: any) => {
        if (value) {
            const e = { TierOccurrence: "" };
            setTierOccurrence(value?.Value)
            setErrors({ ...errors, ...e });
        }
        else {
            const e = { TierOccurrence: "Required" };
            setErrors({ ...errors, ...e });
            setTierOccurrence(1)
        }
    };

    const handleNotes = (e: any) => {
        const trimmedValue = e.target.value;
        setFootnote(trimmedValue);
        if (trimmedValue.length > 30) {
            const e = { FootNote: "Footnote should not exceed 30 characters" }
            errors.FootNote = "Footnote should not exceed 30 characters";
            setErrors({ ...errors, ...e });
        }
        else {
            errors.FootNote = ""
            setErrors({ ...errors, ...errors });
        }
    }
    const handlePlanName = (value) => {
        const trimmedValue = value.trim();
        const isWhitespace = trimmedValue.length === 0;
        setErrors({ ...errors, AddonName: value?.length > 30 ? "Name should not exceed 30 characters" : isWhitespace ? "Required*" : "" })
        setName(value)
    }


    const handleKeyPress = (e) => {
        if ((e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+')) {
            e.preventDefault();
        }
    }

    useEffect(() => {
        FeatureService.GetAllNewFeatures().then((res) => {
            const feature: Feature[] = res.data.map(mapToNewFeature)
            const filteredFeatures = feature.filter(x => x.Code === "GTF");
            setFeatures(filteredFeatures);

            if ((props.IsDuplicate || props.IsEdit) && props.Tier?.Features?.[0]) {
                const tierFeature = props.Tier.Features[0];
                const matchingFeature = filteredFeatures.find(f => f.Code === tierFeature.Code);
                if (matchingFeature) {
                    setSelectedFeature(matchingFeature);
                    if (tierFeature.Value === "-1") {
                        setIsUnlimited(true);
                    } else {
                        setValue(tierFeature.Value);
                        setIsUnlimited(false);
                    }
                }
            }
        }).catch((error) => {
            console.error("Error loading features:", error);
        });
    }, [props.IsDuplicate, props.IsEdit, props.Tier]);

    const handleFeature = (e: any, value: Feature) => {
        setSelectedFeature(value)
        setValue("")
        setIsUnlimited(false)
        setSelectedFeatureError("Please select Unlimited or enter a value.")
    }

    const handleUnlimited = (checked) => {
        setIsUnlimited(checked)
        if (checked) {
            setSelectedFeatureError("")
            setValue("")
        } else {
            !value && setSelectedFeatureError("Please select Unlimited or enter a value.")
        }
    }

    const handleValue = (e) => {
        setValue(e.target.value)
        if (!e.target.value && !isUnlimited) {
            setSelectedFeatureError("Please select Unlimited or enter a value.")
        } else {
            setSelectedFeatureError("")
        }
    }

    return <Dialog
        open={props.show}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        className={"dialogue-shadow"}
        disableEscapeKeyDown
        fullWidth
        onClose={() => props.OnClose(false)} >
        <DialogTitle className="dialog-header p-2">
            <div className="h2-regular color-text-field-font d-flex justify-between">
                {props.IsEdit ? buttonLabels.EDIT_ADDON_PLAN : props.IsDuplicate ? buttonLabels.DUPLICATE_ADDON_PLAN : buttonLabels.ADD_NEW_ADDON_PLAN}
                <Tooltip title='Close' placement='bottom'>
                    <span className="ml-auto">
                        <CancelIcon className={"c-pointer"} onClick={() => props.OnClose(false)} />
                    </span>
                </Tooltip>
            </div>
        </DialogTitle>
        <div className={"bb-primary-background-pink-4 mx-2"}></div>
        <DialogContent className={`pb-0 px-1`} >
            <div className="d-flex flex-direction">
                <div className="d-flex justify-between">
                    <div className="w-p-50">
                        <TextField
                            label="Add-on Name *"
                            variant="outlined"
                            name="Name"
                            value={name}
                            size='small'
                            disabled={props.IsEdit}
                            onChange={(e) => { handlePlanName(e.target.value) }}
                            InputProps={{
                                classes: { input: ` h4-regular color-text-field-font` },
                                style: {
                                    backgroundColor: props.IsEdit ? 'lightgrey' : 'transparent',
                                }
                            }}
                            className="mx-1 my-1 w-fill" />
                        <FormHelperText className={`h5-regular mx-1 color-primary-danger t-align-right mr-1`}>
                            {errors.AddonName}
                        </FormHelperText>
                    </div>
                    <div className="w-p-50">
                        <TextField
                            label="Footnote"
                            variant="outlined"
                            size='small'
                            name="footNote"
                            value={footnote}
                            onChange={handleNotes}
                            InputProps={{ classes: { input: `h4-regular color-text-field-font` } }}
                            className="mx-1 my-1 w-fill" />
                        <FormHelperText className="h5 mx-1 color-primary-danger t-align-right">
                            {errors.FootNote}
                        </FormHelperText>
                    </div>
                </div>
                <div className="d-flex  justify-between">
                    <div className="w-p-50">
                        <Autocomplete
                            size="small"
                            className={"mx-1 my-1 w-fill"}
                            classes={{
                                input: `${'h4-regular'} color-text-field-font`,
                                paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow'
                            }}
                            options={countries}
                            disableClearable
                            getOptionLabel={(option: any) => option.Name}
                            onChange={(event: any, value: any | null) => {
                                if (value) {
                                    setCountry(value.ISO);
                                    const e = { CountryError: "" }
                                    setErrors({ ...errors, ...e })
                                }
                                else {
                                    setCountry("");
                                    const e = { CountryError: "Required*" }
                                    setErrors({ ...errors, ...e })
                                }
                            }}
                            value={countries.find(x => x.ISO === country)}
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => {
                                return (<TextField {...params} name="country" required variant="outlined" label="Select Country" placeholder="Select Country"
                                // inputProps={{ ...params.inputProps, autoComplete: 'new-password' }} 
                                />)
                            }}
                        />
                        <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                            {errors.CountryError}
                        </FormHelperText>
                    </div>

                    <div className="w-p-50">
                        <TextField
                            required
                            className="mx-1 my-1 w-fill"
                            type="number"
                            size='small'
                            name="Price"
                            value={price}
                            label={"Price"}
                            variant="outlined"
                            onChange={(e) => handlePrice(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                        />
                        <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                            {errors.Price}
                        </FormHelperText>
                    </div>
                </div>
                <div className="d-flex flex-direction-row justify-between">
                    <div className="w-p-50 d-flex flex-direction justify-between">
                        <Autocomplete
                            size="small"
                            className={"mx-1 my-1 w-fill"}
                            classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={tierOccurrences}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handleTierOccurrenceChange}
                            disabled
                            value={tierOccurrences.find(x => x.Value === tierOccurrence)
                                || { Name: "", Value: -1 }
                            }
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="TierOccurrence" required variant="outlined" label="Select Tier Occurrence" placeholder="Select Tier Occurrence" />}
                        />
                        <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                            {errors.TierOccurrence}
                        </FormHelperText>
                    </div>
                </div>
                <div>
                    <div className="d-flex justify-between align-center">
                        <Autocomplete
                            size="small"
                            className={"mx-1 my-1 w-fill"}
                            classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={features}
                            getOptionLabel={(option: any) => option?.Name ?? ''}
                            onChange={handleFeature}
                            value={selectedFeature ? features.find(x => x.Code === selectedFeature?.Code) : null} // Handle null case
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="SelectFeature" required variant="outlined" label="Select Feature" placeholder="Select Feature" />}
                        />
                        <FormControlLabel
                            control={<Checkbox
                                defaultChecked={false}
                                checked={isUnlimited}
                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                onChange={(e) => handleUnlimited(e?.target.checked)}
                            />}
                            label={"unlimited"}
                        />
                        <TextField
                            type="number"
                            name="value"
                            value={value}
                            label="Value"
                            variant="outlined"
                            onChange={(e) => handleValue(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            autoComplete=""
                            size="small"
                            required
                            disabled={isUnlimited}
                            InputProps={{
                                style: {
                                    backgroundColor: isUnlimited ? 'lightgrey' : 'transparent',
                                }
                            }}
                            className="mx-1  w-fill" />
                    </div>
                    <FormHelperText className="h5 color-primary-danger t-align-right ml-auto mr-1">
                        {selectedFeatureError}
                    </FormHelperText>
                </div>

            </div>
        </DialogContent>

        <DialogActions className={`p-2`}>
            <ButtonComponent
                OnClick={onSubmitAddon}
                Loading={isLoading}
                ButtonLabel={props.IsEdit ? buttonLabels.UPDATE_ADD_ON_PLAN : props.IsDuplicate ? buttonLabels.DUPLICATE_ADDON_PLAN : "Create Add-On"}
                ClassName={"ml-auto mr-1 pl-4 pr-4"}
                Variant={isValidForm() ? "primary-btn-small" : "disabled-btn-small"} />
            <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} />
        </DialogActions>
    </Dialog>
}

export default CreatEditAddon;